var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2657",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 98
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 97.0439,
    height: 97.0439,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2657)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0000610352,
    y: -43.8247,
    width: 90.783,
    height: 134.609,
    fill: "#FFECB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_2657",
    transform: "translate(-0.00416667) scale(0.00833333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_2657",
    width: 121,
    height: 120,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.b17ccaa840581e7ae30efcfe31b7d477.svg";
export { ForwardRef as ReactComponent };